import { ofType } from 'redux-observable';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  addedActionAction,
  setCurrentActionAction
} from '../../reducers/actions';
import { ActionService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_ACTION),
    switchMap(action =>
      ActionService.create(action.action, store).pipe(
        switchMap(data =>
          concat(of(addedActionAction(data)), of(setCurrentActionAction(data)))
        ),
        catchError(retryAuthentication(action$, 'epics/actions/addAction'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/actions/addAction.js